import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberFormat from "react-number-format";
import SpecialFlowDropDown from "../../../components/dropDown/specialFlow";
import {InputText} from "primereact/inputtext";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {dataTableBoldText} from "../../../utils/formatters/Text";


const Settlement = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle={
                            localStorage.getItem('institution') !== 'Interno' ?
                                "Administracion \\ Liquidación de Instrucciones" :
                                "Operación \\ Liquidación de Instrucciones"}
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getSettlement}>
                            <div className="p-grid">
                                <div className="p-col-4">
                                    <SubtitleLabel header="Folio del Préstamo" isBold={true}/>
                                    <NumberFormat
                                        name="loanIdFilter"
                                        thousandSeparator={false}
                                        onChange={props.saveFilters}
                                        value={props.loanIdFilter}
                                        customInput={InputText}
                                        maxLength={9}
                                        allowNegative={false}
                                        decimalScale={0}/>
                                </div>
                                <div className="p-col-4">
                                    <SubtitleLabel header="Flujo" isBold={true}/>
                                    <SpecialFlowDropDown
                                        name="catFlowFilter"
                                        filter="descripcionId"
                                        save={props.saveFilters}
                                        value={props.catFlowFilter}
                                        loading={props.loading}/>
                                </div>
                                <div className="p-col-4">
                                    <br/>
                                    <Button
                                        style={{'float': 'right'}}
                                        label="Limpiar"
                                        className="p-button-secondary"
                                        onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.settlementList}
                            expandedRows={props.expandedRows}
                            onRowToggle={props.handleToggle}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column expander={true} style={{width: '3em'}}/>
                            <Column field="idFolioPrest" header="Folio" style={{textAlign: 'left', }} sortable={true}
                                    body={dataTableBoldText}
                            />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Settlement;